import { useEffect, useState } from 'react';

// Keep these in step with the breakpoints in _tokens.scss.
export const BELOW_SIDEBAR_QUERY = '(max-width: 1279px)';
export const BELOW_TABLET_QUERY = '(max-width: 1023px)';

function matchesNow(query) {
  return typeof window !== 'undefined' && !!window.matchMedia
    ? window.matchMedia(query).matches
    : false;
}

// Whether the window currently matches a media query, kept up to date as the
// window is resized. False where media queries are not available (for example
// on the server), so the wide layout is the default.
// `afterMount` starts as false even in a browser and takes the real answer once
// the component has mounted: for what the server also renders, so that the
// browser's first render matches the server's (a mismatch is not repaired).
function useMediaQuery(query, { afterMount = false } = {}) {
  const [matches, setMatches] = useState(
    () => !afterMount && matchesNow(query)
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const list = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    setMatches(list.matches);
    if (list.addEventListener) {
      list.addEventListener('change', handleChange);
      return () => list.removeEventListener('change', handleChange);
    }
    list.addListener(handleChange);
    return () => list.removeListener(handleChange);
  }, [query]);

  return matches;
}

export default useMediaQuery;
